var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { compose, replace } from 'ramda';
import { decapitalize } from './strings';
var formKeyForColumn = compose(replace(/\s/g, ''), decapitalize);
export var getTableColumn = function (column) {
    var key = formKeyForColumn(column === null || column === void 0 ? void 0 : column.title);
    return __assign(__assign({}, column), { dataIndex: key, key: key });
};
export var getOrganizationStructure = function (organization) {
    var _a;
    return ({
        orgTpaAbr: ((_a = organization === null || organization === void 0 ? void 0 : organization.third_party_admin) === null || _a === void 0 ? void 0 : _a.abbr) || '',
        orgTpaGroupName: (organization === null || organization === void 0 ? void 0 : organization.tpa_group) || ''
    });
};
export var getOrganizationName = function (organization) {
    var _a;
    var orgName = (organization === null || organization === void 0 ? void 0 : organization.name) || '';
    var orgAbr = ((_a = organization === null || organization === void 0 ? void 0 : organization.third_party_admin) === null || _a === void 0 ? void 0 : _a.abbr) || '';
    var orgFullName = orgName;
    if (orgAbr)
        orgFullName = "".concat(orgAbr, " - ").concat(orgName);
    return orgFullName || 'N/A';
};
